import React, {useEffect, useState, Suspense} from 'react'
import {Switch, Route, withRouter, useHistory} from 'react-router-dom'
import jwtDecodeAndStore from './modules/common/utils/jwtDecodeAndStore'
import {setAccessToken} from './modules/common/utils/api'
import useWindowSize from './modules/common/hooks/windowSize'
import Demo from './modules/demo/Demo'
// import Audit from './modules/audit/Audit'
// import Barcode from './modules/barcode/Barcode'
import Group from './modules/group/Group'
import AuditMain from './components/AuditMain'
import Reports from './modules/reports/Reports'
import Home from './modules/home/Home'
import PasswordResetWeb from './modules/auth/PasswordResetWeb'
import {ThemeProvider, StylesProvider} from '@material-ui/styles'
import {Box, createMuiTheme} from '@material-ui/core'
import Cookies from 'js-cookie'
import BarcodeMain from './components/BarcodeMain'
import ReservationMain from './components/ReservationMain'
import ReservationConfigurationMain from './components/ReservationConfigurationMain'
import ReservationReserve from './components/ReservationReserve'
import CalendarMain from './components/ReservationCalendar/WelcomeCalendar/CalendarMain'
import SetupWizardContainer from './components/SetupWizard/SetupWizardContainer'

import {ReservationProvider} from './context/Reservation'
import {UserContextProvider} from './context/User'
import ReservationInitialize from './components/ReservationInitialize'
import {ReservationPopMain} from './components/ReservationPopReserve/ReservationPopUpReserve/ReservationPopMain'
function App({location}) {
  const [jwtLoaded, setJwtLoaded] = useState(false)
  // eslint-disable-next-line
  const [mobileScreen, setMobileScreen] = useState(false)
  // eslint-disable-next-line
  const [colorTheme, setColorTheme] = useState(localStorage.getItem('color_theme') || 'light')
  const history = useHistory()
  const {width} = useWindowSize()
  const pandaMaterialTheme = createMuiTheme({
    palette: {
      primary: {
        main: '#4791db',
      },
      secondary: {
        main: '#e33371',
      },
      type: colorTheme,
    },
  })

  //Decode jwt token on first mount only and store token, then callback update axios instance with auth header
  useEffect(() => {
    jwtDecodeAndStore(() => {
      // setAccessToken will create a "Access-Token" and "Authorization" headers in api request.
      setAccessToken(JSON.parse(window.localStorage.getItem('token')))
      setJwtLoaded(true)
    })
  }, [])

  useEffect(() => {
    if (
      window.localStorage.getItem('temp_password') === 'true' &&
      location.pathname !== '/password_reset'
    ) {
      history.push({pathname: '/password_reset'})
    } else if (
      window.localStorage.getItem('temp_password') === 'false' &&
      location.pathname === '/password_reset'
    ) {
      history.push({pathname: '/'})
    }
  }, [location.pathname, history])

  useEffect(() => {
    const isMobile = width < 600
    window.localStorage.setItem('is_mobile', isMobile)
    setMobileScreen(isMobile)
  }, [width])

  useEffect(() => {
    window.addEventListener('mousedown', clickListener)
    return () => window.removeEventListener('mousedown', clickListener)
  }, [])

  useEffect(() => {
    let parent_origin = process.env.REACT_APP_ROOT_API_URL // fallback
    if (window !== window.parent) {
      parent_origin = document.referrer
        ? new URL(document.referrer).origin
        : process.env.REACT_APP_ROOT_API_URL // fallback
    }
    window.localStorage.setItem('parent_origin', parent_origin)
  }, [])

  function clickListener(event) {
    const jwtCookie = Cookies.get('pwa_jwt')
    const expirationDate = new Date(
      new Date().getTime() + parseInt(window.localStorage.getItem('session_expire')) * 60 * 1000
    )

    if (jwtCookie) {
      Cookies.set('pwa_jwt', jwtCookie, {
        expires: expirationDate,
        domain: process.env.REACT_APP_SESSION_DOMAIN,
      })
      if (window !== window.parent) {
        if (document.referrer === process.env.REACT_APP_BARCODE_WINDOW_URL) {
          window.parent.postMessage('extendSession', process.env.REACT_APP_BARCODE_WINDOW_URL)
        } else if (document.referrer === process.env.REACT_APP_AUDIT_WINDOW_URL) {
          window.parent.postMessage('extendSession', process.env.REACT_APP_AUDIT_WINDOW_URL)
        } else if (document.referrer === process.env.REACT_APP_RESERVATION_CALENDAR_WINDOW_URL) {
          const calendarUrls = process.env.REACT_APP_RESERVATION_CALENDAR_WINDOW_URL.split(', ')
          calendarUrls.forEach(targetOrigin => {
            window.parent.postMessage('extendSession', targetOrigin)
          })
        }
      }
    } else {
      const topWindow = window !== window.parent ? window.top : window
      topWindow.location.href = process.env.REACT_APP_REDIRECT_URL
    }
    return
  }

  //function loadPage() {
  //  if (window !== window.parent) {
  //    if (document.referrer === process.env.REACT_APP_BARCODE_WINDOW_URL) {
  //      return '/barcode_generator'
  //    }
  //  }
  //  return '/'
  //}

  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={pandaMaterialTheme}>
        {/* Next line only loads the app div and children once api token is available */}
        {jwtLoaded && (
          // <Suspense fallback="loading">
          <Suspense fallback="loading">
            <Box
              display="flex"
              flexDirection="column"
              //height="100vh"
              //overflow="hidden"
              background="background.paper"
            >
              <Box display="flex" flexDirection="column" flexGrow="1" overflow="hidden">
                {/* <Redirect to={loadPage()} /> */}
                <Switch>
                  <Route path="/audits">
                    <AuditMain />
                  </Route>
                  <Route
                    path={[
                      '/barcode_generator',
                      '/barcode-wizard-generate-setting',
                      '/barcode-wizard-auto-form',
                      '/barcode-wizard-field-value-form',
                      '/barcode-wizard-generate-field-value',
                      '/barcode-library',
                      '/new-label',
                      '/edit-label/:id',
                      '/barcode-wizard',
                      '/barcode-libray-reprint',
                      '/barcode-library-preview',
                      '/barcode-libray-generate-automatic',
                      '/barcode-wizard-generate-automatic',
                      '/not-available-mobile',
                    ]}
                  >
                    <BarcodeMain />
                  </Route>
                  <Route path="/tools/demo">
                    <Demo />
                  </Route>
                  <Route path="/groups">
                    <Group />
                  </Route>
                  <Route path="/reports">
                    <Reports />
                  </Route>
                  <Route exact path="/password_reset">
                    <PasswordResetWeb />
                  </Route>
                  <Route path="/reservations/configuration">
                    <ReservationConfigurationMain />
                  </Route>
                  <Route path="/reservations/pop_reserve">
                    <ReservationPopMain />
                  </Route>
                  <Route path="/reservations">
                    <ReservationMain />
                  </Route>
                  <Route path="/reservations_calendar">
                    <CalendarMain />
                  </Route>
                  <Route exact path="/">
                    <Home />
                  </Route>
                  <Route path="/setup_wizard">
                    <SetupWizardContainer />
                  </Route>
                </Switch>
              </Box>
            </Box>
          </Suspense>
        )}
      </ThemeProvider>
    </StylesProvider>
  )
}

export default withRouter(App)
